<template>
  <BaseFilterBar
    :search-placeholder="searchPlaceholder"
    :search="search"
    :filters="filters"
    :values="filterValues"
    :show-search="showSearch"
    @filter-change="handleFilterChange"
    @submit="handleSubmit"
  />
</template>

<script>
import BaseFilterBar from './BaseFilterBar.vue'
import FilterBarEvents from '../../mixins/FilterBarEvents.js'

export default {
  name: 'BaseFilterBarStandalone',
  components: { BaseFilterBar },
  mixins: [FilterBarEvents],
  props: {
    searchPlaceholder: {
      type: String,
      required: false,
      default: ''
    },
    search: {
      type: String,
      required: false,
      default: ''
    },
    filters: {
      type: Array,
      required: false,
      default: () => []
    },
    filterValues: {
      type: Object,
      required: false,
      default: () => ({})
    },
    showSearch: {
      type: Boolean,
      required: false,
      default: true
    },
    instance: {
      type: String,
      required: false,
      default: ''
    },
    autoFetchOnChange: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>
